const state = {
  historicoNotificacoes: Array
}

const mutations = {
  setHistoricoNotificacoes (state, obj) {
    state.historicoNotificacoes = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/historicoNotificacoes.js